import {
  AD_ACCOUNT_PLATFORMS_LABELS,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_RETARGETING_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION,
  ADS_TIKTOK_PLACEMENT_TIKTOK,
  FONT_FAMILY,
  TIKTOK,
} from "../../../../utils/constants";
import Grid from "@mui/material/Grid";
import useFocusErrorForm from "../../../../hooks/useFocusErrorForm";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslationApp } from "../../../../lib/i18next";
import SelectBusinessAccount from "../../../Meta/SelectBusinessAccount";
import {
  ACTIVE,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE,
  ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL,
  ADS_CONFIGURATION_APPS_TITLE,
  ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE,
  ALERT_CHANGE_AD_ACCOUNT_TIKTOK_DESCRIPTION,
  APP_PLACEHOLDER,
  BUTTON_CANCEL,
  BUTTON_CONTINUE,
  DAILY_BUDGET_PLACEHOLDER,
  DEACTIVATED,
  FIELD_REQUIRED,
  IDENTITY_TIK_TOK_PLACEHOLDER,
  IOS_14_CAMPAIGN_PLACEHOLDER,
  LIFETIME_BUDGET_PLACEHOLDER,
  OBJECTIVE_PLACEHOLDER,
  TYPE_BUDGET_PLACEHOLDER,
  TYPE_PLACEHOLDER,
  USE_CAMPAIGN_BUDGET_PLACEHOLDER,
  ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_PLACEHOLDER,
} from "../../../../i18n/keysTranslations";
import {
  optionsAdsCampaignAppPromotionTypesTikTok,
  optionsAdsCampaignObjectivesTikTok,
  optionsAdsCampaignSpecialAdCategoriesTikTok,
  optionsAdsCampaignTypeBudgets,
  optionsAdsSalesCampaignTypeTikTok,
} from "../../../../utils/options";
import AutocompleteField from "../../../Form/AutocompleteField";
import Select from "../../../Form/Select";
import SelectTikTokIdentityCustom from "../../../Form/SelectTikTokIdentityCustom";
import ReasoningContainer from "../../../../pages/NewAdsCampaign/components/Common/ReasoningContainer";
import { ConfirmAlert } from "../../../Alerts/Alerts";
import Typography from "@mui/material/Typography";
import Switch from "../../../Form/Switch";
import TextField from "../../../Form/TextField";
import NumberField from "../../../Form/NumberField";
import { getCurrencyAdAccountPlatform } from "../../../../actions/getters";
import { useDispatchApp } from "../../../../lib/redux";
import SelectAdvertisableAppsTikTok from "../AdGroup/SelectAdvertisableAppsTikTok";
import { Box } from "@mui/material";
import CardContainer from "../../../Card/CardContainer";

const platform = TIKTOK;
const grid = {
  xs: 12,
  lg: 6,
};
const CampaignTikTokForm = () => {
  const {
    control,
    formState,
    watch,
    setValue,
    getValues,
    isGeneralDisabledFields,
    getIsCampaignPlatformCreated,
  } = useFormContext();
  useFocusErrorForm(formState);
  const errors = formState.errors;

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();

  const isCampaignPlatformCreated = getIsCampaignPlatformCreated(platform);

  const basicPath = `platformsData.${platform}`;
  const platformData = watch(basicPath) || {};
  const isIncompatible = platformData?.isIncompatible;
  const objective = platformData?.objective;
  const isIOS14Campaign = platformData?.isIOS14Campaign;
  const type = platformData?.type;
  const useCampaignBudget = platformData?.useCampaignBudget || false;
  const typeBudget = platformData?.typeBudget;

  const currency = dispatch(
    getCurrencyAdAccountPlatform({
      platform,
      integrationID: platformData?.integrationID,
      adAccountID: platformData?.adAccountID,
    })
  );
  const isDisabledFields = isIncompatible || isGeneralDisabledFields;

  const validationChangeAdAccount = async () => {
    const result = await ConfirmAlert({
      title: t(ALERT_CHANGE_AD_ACCOUNT_GENERAL_TITLE),
      html: (
        <Typography
          variant="body1"
          sx={{
            fontFamily: FONT_FAMILY,
            "& *": {
              p: "revert",
              m: "revert",
              listStyle: "revert",
              textDecoration: "revert",
            },
          }}
          dangerouslySetInnerHTML={{
            __html: t(ALERT_CHANGE_AD_ACCOUNT_TIKTOK_DESCRIPTION),
          }}
        />
      ),
      confirmButtonText: t(BUTTON_CONTINUE),
      cancelButtonText: t(BUTTON_CANCEL),
    });

    if (!result.isConfirmed) return false;

    return true;
  };

  const onChangeAdAccount = (value) => {
    setValue(`${basicPath}.integrationID`, value?.integrationID);
    setValue(`${basicPath}.identityTikTokID`, "");
    setValue(`${basicPath}.appID`, "");
    setValue(`${basicPath}.budget`, "");

    const adsGroups = getValues("adsGroups");
    adsGroups.forEach((adGroup, index) => {
      if (adGroup.platform !== TIKTOK) return;

      setValue(`adsGroups.[${index}].trackingID`, "");
      setValue(`adsGroups.[${index}].trackingCustomEventID`, "");
      setValue(`adsGroups.[${index}].appID`, "");
      setValue(`adsGroups.[${index}].budget`, "");

      const ads = adGroup?.ads || [];
      ads.forEach((ad, indexAd) => {
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaIDs`, []);
      });
    });
  };

  const onClearConfigurationIOS14Campaign = ({ value }) => {
    if (!value) {
      setValue(`${basicPath}.appID`, "");
    }

    if (value) {
      onUpdateAdGroupsAppPromotion({
        appID: "",
      });
    }
  };
  const onUpdateAdGroupsAppPromotion = ({ appID }) => {
    const adsGroups = getValues("adsGroups");

    adsGroups.forEach((adGroup, index) => {
      if (adGroup.platform !== TIKTOK) return;

      setValue(`adsGroups.[${index}].appID`, appID);
    });
  };

  const onChangeObjective = (value) => {
    if (
      value === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION ||
      value === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION
    ) {
      const adsGroups = getValues("adsGroups");
      adsGroups.forEach((adGroup, index) => {
        if (adGroup.platform !== TIKTOK) return;
        setValue(`adsGroups.[${index}].placements`, [
          ADS_TIKTOK_PLACEMENT_TIKTOK,
        ]);
        const ads = adGroup?.ads || [];
        ads.forEach((ad, indexAd) => {
          if (!ad.isCarousel) return;

          setValue(`adsGroups.[${index}].ads.[${indexAd}].musicUrl`, null);
          setValue(`adsGroups.[${index}].ads.[${indexAd}].musicID`, null);
          setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaUrls`, []);
          setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaData`, []);
          setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaIDs`, []);
          setValue(`adsGroups.[${index}].ads.[${indexAd}].isCarousel`, false);
        });
      });
    }
  };

  return (
    <Grid container spacing={2}>
      {!isCampaignPlatformCreated && (
        <Grid item xs={12}>
          <ReasoningContainer platform={platform} />
        </Grid>
      )}

      {/* CARD GENERAL CONFIGURATION */}
      <Grid item xs={12}>
        <CardContainer
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t(ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_GENERAL)}
              </Typography>
            </Box>
          }
        >
          <Grid container spacing={3}>
            <Grid item {...grid}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                {t(OBJECTIVE_PLACEHOLDER)}
              </Typography>
              <Select
                options={optionsAdsCampaignObjectivesTikTok}
                disabled={isCampaignPlatformCreated || isDisabledFields}
                name={`${basicPath}.objective`}
                actionsChange={onChangeObjective}
                variant="filled"
                fullWidth
                doTranslate={true}
                control={control}
                errors={errors}
                rules={{
                  required: {
                    value: true,
                    message: t(FIELD_REQUIRED),
                  },
                }}
              />
            </Grid>

            {objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION && (
              <Grid item {...grid}>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {t(TYPE_PLACEHOLDER)}
                </Typography>
                <Select
                  options={optionsAdsCampaignAppPromotionTypesTikTok}
                  disabled={isCampaignPlatformCreated || isDisabledFields}
                  name={`${basicPath}.type`}
                  variant="filled"
                  fullWidth
                  doTranslate={true}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                  }}
                />
              </Grid>
            )}

            {objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION && (
              <Grid item {...grid}>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {t(TYPE_PLACEHOLDER)}
                </Typography>
                <Select
                  options={optionsAdsSalesCampaignTypeTikTok}
                  disabled={true}
                  name={`${basicPath}.type`}
                  variant="filled"
                  fullWidth
                  doTranslate={true}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: true,
                      message: t(FIELD_REQUIRED),
                    },
                  }}
                />
              </Grid>
            )}

            <Grid item {...grid}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                {t(AD_ACCOUNT_PLATFORMS_LABELS[platform])}
              </Typography>
              <SelectBusinessAccount
                variant="filled"
                disabled={isCampaignPlatformCreated || isDisabledFields}
                control={control}
                platform={platform}
                name={`${basicPath}.adAccountID`}
                onChangeAction={onChangeAdAccount}
                validationChange={validationChangeAdAccount}
                errors={errors}
                fullWidth={true}
                rules={{
                  required: {
                    value: true,
                    message: t(FIELD_REQUIRED),
                  },
                }}
              />
            </Grid>

            <Grid item {...grid}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                {t(IDENTITY_TIK_TOK_PLACEHOLDER)}
              </Typography>
              <SelectTikTokIdentityCustom
                objective={objective}
                type={type}
                adAccountID={platformData?.adAccountID}
                integrationID={platformData?.integrationID}
                name={`${basicPath}.identityTikTokID`}
                fullWidth
                variant="filled"
                control={control}
                errors={errors}
                disabled={
                  isCampaignPlatformCreated ||
                  !platformData?.adAccountID ||
                  isDisabledFields
                }
                rules={{
                  required: {
                    value: true,
                    message: t(FIELD_REQUIRED),
                  },
                }}
              />
            </Grid>

            <Grid item {...grid}>
              <Typography variant="body1" sx={{ mb: 1 }}>
                {t(ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_PLACEHOLDER)}
              </Typography>
              <AutocompleteField
                name={`${basicPath}.specialAdCategories`}
                control={control}
                errors={errors}
                options={optionsAdsCampaignSpecialAdCategoriesTikTok}
                doTranslate={true}
                fullWidth
                multiple={true}
                variant="filled"
                disabled={isCampaignPlatformCreated || isDisabledFields}
              />
            </Grid>
          </Grid>
        </CardContainer>
      </Grid>

      {/* CARD APPS */}
      {objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION &&
        type !== ADS_CAMPAIGN_APP_PROMOTION_TYPE_RETARGETING_OPTION && (
          <Grid item xs={12}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(ADS_CONFIGURATION_APPS_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <Grid container spacing={3}>
                {objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION && (
                  <Grid item {...grid}>
                    <Typography variant="body1">
                      {t(IOS_14_CAMPAIGN_PLACEHOLDER)}
                    </Typography>
                    <Controller
                      name={`${basicPath}.isIOS14Campaign`}
                      control={control}
                      render={({ field }) => (
                        <Switch
                          disabled={
                            isCampaignPlatformCreated || isDisabledFields
                          }
                          labelActive={ACTIVE}
                          labelDeactivate={DEACTIVATED}
                          isActive={field.value}
                          labelPlacement="end"
                          onChangeIsActive={(value) => {
                            field.onChange(value);

                            onClearConfigurationIOS14Campaign({
                              value,
                            });
                          }}
                        />
                      )}
                    />
                  </Grid>
                )}

                {objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION &&
                  isIOS14Campaign && (
                    <Grid item {...grid}>
                      <Typography variant="body1" sx={{ mb: 1 }}>
                        {t(APP_PLACEHOLDER)}
                      </Typography>
                      <SelectAdvertisableAppsTikTok
                        disabled={isCampaignPlatformCreated || isDisabledFields}
                        platform={TIKTOK}
                        adAccountID={platformData?.adAccountID}
                        integrationID={platformData?.integrationID}
                        isIOS14Campaign={isIOS14Campaign}
                        campaignType={type}
                        name={`${basicPath}.appID`}
                        fullWidth
                        variant="filled"
                        control={control}
                        errors={errors}
                        onChangeAction={(value) => {
                          onUpdateAdGroupsAppPromotion({
                            appID: value?.id,
                          });
                        }}
                      />
                    </Grid>
                  )}
              </Grid>
            </CardContainer>
          </Grid>
        )}

      {/* CARD BUDGET INFORMATION */}
      <Grid item xs={12}>
        <CardContainer
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t(ADS_CAMPAIGN_AD_GROUP_BUDGET_INFORMATION_SUB_TITLE)}
              </Typography>
            </Box>
          }
        >
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Typography variant="body1">
                {t(USE_CAMPAIGN_BUDGET_PLACEHOLDER)}
              </Typography>
              <Controller
                name={`${basicPath}.useCampaignBudget`}
                control={control}
                render={({ field }) => (
                  <Switch
                    disabled={isCampaignPlatformCreated || isDisabledFields}
                    labelActive={ACTIVE}
                    labelDeactivate={DEACTIVATED}
                    isActive={field.value}
                    labelPlacement="end"
                    onChangeIsActive={(value) => {
                      const adsGroups = getValues("adsGroups");
                      adsGroups.forEach((adGroup, index) => {
                        if (adGroup.platform !== TIKTOK) return;
                        setValue(`adsGroups.[${index}].budget`, "");
                        setValue(`adsGroups.[${index}].typeBudget`, "");
                      });
                      setValue(`${basicPath}.typeBudget`, "");
                      field.onChange(value);
                    }}
                  />
                )}
              />
            </Grid>

            {useCampaignBudget && (
              <>
                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {t(TYPE_BUDGET_PLACEHOLDER)}
                  </Typography>
                  <Select
                    disabled={isCampaignPlatformCreated || isDisabledFields}
                    name={`${basicPath}.typeBudget`}
                    actionsChange={(value) => {
                      const adsGroups = getValues("adsGroups");
                      adsGroups.forEach((adGroup, index) => {
                        if (adGroup.platform !== TIKTOK) return;
                        setValue(`adsGroups.[${index}].typeBudget`, value);
                      });
                    }}
                    fullWidth
                    variant="filled"
                    doTranslate={true}
                    options={optionsAdsCampaignTypeBudgets}
                    control={control}
                    errors={errors}
                    rules={{
                      required: {
                        value: true,
                        message: t(FIELD_REQUIRED),
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    {t(
                      typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION
                        ? DAILY_BUDGET_PLACEHOLDER
                        : LIFETIME_BUDGET_PLACEHOLDER,
                      {
                        currency: currency.toUpperCase(),
                      }
                    )}
                  </Typography>
                  <TextField
                    name={`${basicPath}.budget`}
                    disabled={isDisabledFields}
                    fullWidth
                    variant="filled"
                    InputProps={{
                      inputComponent: NumberField,
                    }}
                    control={control}
                    errors={errors}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </CardContainer>
      </Grid>
    </Grid>
  );
};

export default CampaignTikTokForm;
